<template>
	<div class="action-bar-container">
		<div class="action-bar">
				<button
					v-for="(action, index) in actions"
					v-bind:class="{ active: action.active }"
					v-on:click="actionToDo(action)"
					:key="index"
					type="button">
					<div class="action-bar-element">
						<img 
						:src="action.img" v-bind:alt="action.text" width="24px">
						<span>{{ action.text }}</span>
					</div>
				</button>
		</div>
	</div>
</template>

<script>
function actionToDo(item) {
	const newObject = {
		width: item.width ? item.width : 0,
		title: item.text,
		code: item.code,
		active: item.active,
		open: true,
	};
	const action = item.link || { ...newObject };
	const eventEmit = item.link ? 'to-link' : 'open-modal';
	this.$emit(eventEmit, action);
}

export default {
	name: 'action-bar',
	methods: {
		actionToDo,
	},
	props: {
		actions: Array,
	},
};
</script>

<style lang="scss" scoped>
.action-bar-container {
	align-items: center;
	display: flex;
	flex-direction: column;
	flex: 0 1 80vh;
	position: absolute;
	right: -8px;
	z-index: 3;
}

.action-bar {
	display: flex;
	flex-flow: column;
}

.action-bar-element {
	align-items: center;
	background-color: white;
	border: 1px solid color(blue-price);
	border-radius: 4px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
	color: color(subheaderText);
	display: grid;
	font-size: 12px !important;
	grid-template-columns: 30px 1fr;
	grid-template-rows: 40px;
	margin-bottom: 5px;
	padding: 0 11px;
	text-align: left;
	transform: translateX(70px);
	transition: transform 200ms ease-out;
	width: 120px;
}

.action-bar-element:hover {
	transform: translateX(-6px);
}
</style>




// WEBPACK FOOTER //
// src/components/shared/action-bar.vue